import React, { useContext, useEffect, useState } from 'react'
import "./style.scss"
import Icon from 'react-icons-kit'
import {
    activity, bookOpen, globe, info, mail, phoneOutgoing, users, eye, lock, checkCircle
} from 'react-icons-kit/feather'
import { UserContext } from '../../../utils/context/userContext'
import ContactInfo from '../Modal/ContactInfo'
import Requests from "../../../utils/Requests/Index"
import { toast } from 'react-toastify'

const OrNA = value => value || 'Not added'

const Index = ({ data }) => {
    const [contactModel, setContactModel] = useState(false)
    const [contactShow, setContactShow] = useState(false)
    const { user, handleRefetch } = useContext(UserContext)
    const [header] = useState({ headers: { Authorization: "Bearer " + localStorage.getItem('token') } })

    const updateContactViewed = async userId => {
        try {
            // This if else for UX;
            if (user?.packageInfo?.proposal?.contactViewLimit <= 0) {
                toast.warning("Your contact viewed limit finished!")
                return
            } else {
                setContactShow(true)
            }

            const response = await Requests.Profile.UpdateContactViewed(userId, header)
            if (response?.status) {
                toast.success(response.message)
                handleRefetch()
            }
        } catch (error) {
            console.log(error)
        }
    }

    useEffect(() => {
        if (user?.profileType === "Paid" && user?.packageInfo?.contactViewed?.indexOf(data?._id) > -1) {
            setContactShow(true)
        }
    }, [user, data?._id]) // eslint-disable-line react-hooks/exhaustive-deps

    const handleShowContact = () => {
        if (user?.profileType === "Paid") {
            updateContactViewed(data?._id)
        } else {
            setContactModel(true)
        }
    }

    const address = [
        data?.city,
        data?.stateDevision,
        data?.livingCountry || 'Bangladesh'
    ].filter(Boolean).join(', ')

    const familyRows = [
        { k: 'Family location', v: data?.familyLocation },
        { k: 'Native place', v: data?.nativePlace },
        { k: 'Family type', v: data?.familyType },
        { k: 'Family affluence', v: data?.familyAffluence },
        { k: 'Family value', v: data?.familyValue },
        { k: "Father's name", v: data?.fatherName },
        { k: "Father's status", v: data?.fatherStatus },
        { k: "Mother's name", v: data?.motherName },
        { k: "Mother's status", v: data?.motherStatus },
        { k: 'Your order as child', v: data?.yourOrder },
        { k: 'No. of brothers', v: data?.numberOfBrothers },
        { k: 'Married brothers', v: data?.numberOfBrothersMarried },
        { k: 'No. of sisters', v: data?.numberOfSisters },
        { k: 'Married sisters', v: data?.numberOfSistersMarried },
    ]

    const careerRows = [
        { k: 'Qualification', v: data?.qualification },
        { k: 'College(s) attended', v: data?.institute },
        { k: 'Working with', v: data?.workingWith },
        { k: 'Profession area', v: data?.professionArea },
        { k: 'Annual income', v: data?.annualIncome ? `${data.annualIncome} BDT` : null },
    ]

    return (
        <div className="sp-details">

            {/* About */}
            <section className="sp-card">
                <header className="sp-card-head">
                    <span className="sp-card-icon"><Icon icon={info} size={17} /></span>
                    <div className="sp-card-title">
                        <h5>About</h5>
                        <p>A short introduction</p>
                    </div>
                </header>
                <p className="sp-about">{data?.about || 'This member has not written a description yet.'}</p>
            </section>

            {/* Contact */}
            <section className="sp-card">
                <header className="sp-card-head">
                    <span className="sp-card-icon"><Icon icon={phoneOutgoing} size={17} /></span>
                    <div className="sp-card-title">
                        <h5>Contact Details</h5>
                        <p>Phone and email address</p>
                    </div>
                    {contactShow ?
                        <span className="sp-tag sp-tag-ok"><Icon icon={checkCircle} size={12} /> Unlocked</span>
                        :
                        <span className="sp-tag sp-tag-lock"><Icon icon={lock} size={12} /> Locked</span>}
                </header>

                <div className="sp-contact">
                    <div className="sp-contact-item">
                        <span className="sp-contact-icon"><Icon icon={phoneOutgoing} size={16} /></span>
                        <div>
                            <p className="k">Contact number</p>
                            {contactShow && data?.phone ?
                                <a className="v" href={`tel:${data.phone}`}>{data.phone}</a>
                                :
                                <p className="v is-masked">+8801XXX-XXXXXX</p>}
                        </div>
                    </div>

                    <div className="sp-contact-item">
                        <span className="sp-contact-icon"><Icon icon={mail} size={16} /></span>
                        <div>
                            <p className="k">Email address</p>
                            {contactShow && data?.email ?
                                <a className="v" href={`mailto:${data.email}`}>{data.email}</a>
                                :
                                <p className="v is-masked">{contactShow ? 'Not added' : 'xxxxx@example.com'}</p>}
                        </div>
                    </div>
                </div>

                {!contactShow ?
                    <button type="button" className="sp-unlock" onClick={handleShowContact}>
                        <Icon icon={eye} size={15} />
                        {user?.profileType === "Paid" ? 'Show contact details' : 'Upgrade to view contact'}
                    </button>
                    : null}

                {contactModel ?
                    <ContactInfo show={contactModel} onHide={() => setContactModel(false)} />
                    : null}
            </section>

            {/* Lifestyle */}
            <section className="sp-card">
                <header className="sp-card-head">
                    <span className="sp-card-icon"><Icon icon={activity} size={17} /></span>
                    <div className="sp-card-title">
                        <h5>Lifestyle</h5>
                        <p>Daily routine and food habit</p>
                    </div>
                </header>
                <div className="sp-rows">
                    <div className="sp-row">
                        <span className="sp-row-k">Diet</span>
                        <span className={`sp-row-v ${!data?.lifeStyle ? 'is-empty' : ''}`}>{OrNA(data?.lifeStyle)}</span>
                    </div>
                    <div className="sp-row">
                        <span className="sp-row-k">Blood group</span>
                        <span className={`sp-row-v ${!data?.bloodGroup ? 'is-empty' : ''}`}>{OrNA(data?.bloodGroup)}</span>
                    </div>
                </div>
            </section>

            {/* Background */}
            <section className="sp-card">
                <header className="sp-card-head">
                    <span className="sp-card-icon"><Icon icon={globe} size={17} /></span>
                    <div className="sp-card-title">
                        <h5>Background</h5>
                        <p>Religion, community and address</p>
                    </div>
                </header>
                <div className="sp-rows">
                    <div className="sp-row">
                        <span className="sp-row-k">Religion</span>
                        <span className={`sp-row-v ${!data?.religion ? 'is-empty' : ''}`}>{OrNA(data?.religion)}</span>
                    </div>
                    <div className="sp-row">
                        <span className="sp-row-k">Community / Order</span>
                        <span className={`sp-row-v ${!data?.socialOrder ? 'is-empty' : ''}`}>{OrNA(data?.socialOrder)}</span>
                    </div>
                    <div className="sp-row">
                        <span className="sp-row-k">Mother tongue</span>
                        <span className={`sp-row-v ${!data?.language ? 'is-empty' : ''}`}>{OrNA(data?.language)}</span>
                    </div>
                    <div className="sp-row sp-row-full">
                        <span className="sp-row-k">Present & permanent address</span>
                        <span className="sp-row-v">{address || 'Not added'}</span>
                    </div>
                </div>
            </section>

            {/* Family */}
            <section className="sp-card">
                <header className="sp-card-head">
                    <span className="sp-card-icon"><Icon icon={users} size={17} /></span>
                    <div className="sp-card-title">
                        <h5>Family Details</h5>
                        <p>Family background and siblings</p>
                    </div>
                </header>
                <div className="sp-rows">
                    {familyRows.map((row, i) =>
                        <div className="sp-row" key={i}>
                            <span className="sp-row-k">{row.k}</span>
                            <span className={`sp-row-v ${!row.v ? 'is-empty' : ''}`}>{OrNA(row.v)}</span>
                        </div>
                    )}
                </div>
            </section>

            {/* Education & career */}
            <section className="sp-card">
                <header className="sp-card-head">
                    <span className="sp-card-icon"><Icon icon={bookOpen} size={17} /></span>
                    <div className="sp-card-title">
                        <h5>Education & Career</h5>
                        <p>Qualification and profession</p>
                    </div>
                </header>
                <div className="sp-rows">
                    {careerRows.map((row, i) =>
                        <div className="sp-row" key={i}>
                            <span className="sp-row-k">{row.k}</span>
                            <span className={`sp-row-v ${!row.v ? 'is-empty' : ''}`}>{OrNA(row.v)}</span>
                        </div>
                    )}
                </div>
            </section>
        </div>
    )
}

export default Index
